<template>
  <v-card>
    <v-card-title class="justify-center">
      <h1>
        {{
          (step === 1 ? 'CADASTRAR REDE DE EMPRESAS' :
          step === 2 ? 'INSIRA A CAPA DA REDE' :
          step === 3 ? 'SELECIONE A EMPRESA MATRIZ' :
          'REVISÃO').toUpperCase()
        }}
      </h1>
    </v-card-title>
    <v-divider v-if="!alerta"></v-divider>
    <v-alert
      :value="true"
      type="error"
      style="font-size: 1.2em; width: 100%;"
      class="pa-2"
      v-if="alerta"
    >
      Usuário não encontrado
    </v-alert>

    <v-card-text>
      <v-stepper v-model="step" style="box-shadow: none;">
        <v-stepper-items>
          <v-stepper-content class="pa-0" step="1">
            <v-layout column class="pa-4">
              <v-flex align-self-center>
                <img v-if="imagem && mostrar" :src="imagem" alt="Logo da rede" width="300">
                <v-card elevation="4" height="300" width="300" v-if="!imagem && !croppingLogo">
                  <v-layout justify-center align-center fill-height>
                    <div class="title white--text pa-4 text-xs-center">
                      <v-icon size="150">hide_image</v-icon>
                    </div>
                  </v-layout>
                </v-card>
                <v-layout justify-center align-center fill-height v-if="!imagem">
                  <v-flex xs12 v-show="croppingLogo">
                    <vue-croppie
                      ref="croppieRef"
                      :enableExif="true"
                      :enforceBoundary="true"
                      :enableResize="false"
                      :enableOrientation="false"
                      :mouseWheelZoom="true"
                      :showZoomer="false"
                      :boundary="{ width: 250, height: 250 }"
                      :viewport="{ width: 200, height: 200, type : 'circle' }"
                    ></vue-croppie>
                    <v-btn
                      flat
                      @click="recortarLogo"
                      color="grey darken-2"
                      block
                      class="mt-3"
                    >
                      Recortar imagem
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-btn class="mt-3" block color="info" @click="$refs.logoInput.click()" v-if="mostrar">
                  Inserir imagem
                  <input
                    type="file"
                    style="display:none"
                    accept="image/*"
                    ref="logoInput"
                    @input="carregarLogo"
                  />
                </v-btn>
              </v-flex>

              <v-text-field class="mt-3" outline label="Nome da rede" v-model="nome"/>

              <v-checkbox
                v-model="is_white_label"
                color="primary"
                class="mt-2"
                :hide-details="true"
                label="White Label"
              />

              <v-tabs v-model="tabs" grow color="transparent" slider-color="info">
                <v-tab>Por ID</v-tab>
                <v-tab>Por CPF</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs">
                <v-tab-item lazy>
                  <v-text-field
                    v-if="tabs === 0"
                    v-model="id_pessoa"
                    :loading="loading"
                    box
                    outline
                    color="info"
                    label="Digite o ID do representante"
                  />
                </v-tab-item>
                <v-tab-item lazy>
                  <v-text-field
                    v-if="tabs === 1"
                    v-model="cpf"
                    :loading="loading"
                    box
                    outline
                    color="info"
                    label="Digite o CPF do representante"
                    mask="###.###.###-##"
                  />
                </v-tab-item>
              </v-tabs-items>

              <h3 class="text-xs-center success--text" v-if="pessoa">
                Nome: <b>{{ pessoa.nome }}</b>
              </h3>
            </v-layout>
          </v-stepper-content>

          <v-stepper-content class="pa-0" step="2">
            <v-layout column class="pa-4">
              <v-flex align-self-center>
                <img v-if="capa && mostrar2" :src="capa" alt="Capa da rede" width="500">
                <v-card elevation="4" height="250" width="500" v-if="!capa && !croppingCapa">
                  <v-layout justify-center align-center fill-height>
                    <div class="title white--text pa-4 text-xs-center">
                      <v-icon size="150">hide_image</v-icon>
                    </div>
                  </v-layout>
                </v-card>
                <v-layout justify-center align-center fill-height v-if="!capa">
                  <v-flex xs12 v-show="croppingCapa">
                    <vue-croppie
                      ref="croppieCapaRef"
                      :enableExif="true"
                      :enforceBoundary="true"
                      :enableResize="false"
                      :enableOrientation="false"
                      :mouseWheelZoom="true"
                      :showZoomer="false"
                      :boundary="{ width: 500, height: 250 }"
                      :viewport="{ width: 350, height: 200 }"
                    ></vue-croppie>
                    <v-btn
                      flat
                      @click="recortarCapa"
                      color="grey darken-2"
                      block
                      class="mt-3"
                    >
                      Recortar imagem
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-btn class="mt-3" block color="info" @click="$refs.capaInput.click()" v-if="mostrar2">
                  Inserir imagem
                  <input
                    type="file"
                    style="display:none"
                    accept="image/*"
                    ref="capaInput"
                    @input="carregarImagem"
                  />
                </v-btn>
              </v-flex>
            </v-layout>
          </v-stepper-content>

          <v-stepper-content class="pa-0" step="3">
            <v-layout column class="pa-4">
              <v-autocomplete
                v-model="empresaMatriz"
                :items="empresas"
                :loading="loadingEmpresas"
                outline
                label="Selecione a empresa matriz"
                item-text="nome_fantasia"
                item-value="id"
                return-object
                clearable
              />
              <small class="grey--text">
                Dica: comece digitando o nome fantasia da empresa.
              </small>
            </v-layout>
          </v-stepper-content>

          <v-stepper-content class="pa-0" step="4">
            <v-layout row wrap justify-space-between class="pa-2">
              <v-flex xs6>
                <h4 class="text-xs-center">Empresas sem rede</h4>
                <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;"  class="mr-1">
                  <v-list-tile v-for="(emp, index) in empresasSemRede" :key="index" ripple @click="inserirEmRede(emp, index)">
                    <v-list-tile-avatar>
                      <img v-if="emp.url_logo" :src="emp.url_logo" alt="logo empresa" width="30">
                      <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo empresa" width="30">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="text-xs-center">{{ emp.nome_fantasia }}</v-list-tile-title>
                      <v-list-tile-sub-title class="text-xs-center">{{ emp.cnpj }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="empresasSemRede.length === 0">
                    <v-list-tile-content>
                      <v-list-tile-title class="text-xs-center">Sem empresas no momento</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs6>
                <h4 class="text-xs-center">Empresas da rede</h4>
                <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em" class="ml-1">
                  <v-list-tile v-for="(emp, index) in empresasDaRede" :key="index" ripple @click="removerDaRede(emp, index)">
                    <v-list-tile-avatar>
                      <img v-if="emp.url_logo" :src="emp.url_logo" alt="logo empresa" width="30">
                      <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo empresa" width="30">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="text-xs-center">{{ emp.nome_fantasia }}</v-list-tile-title>
                      <v-list-tile-sub-title class="text-xs-center">{{ emp.cnpj }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="empresasDaRede.length === 0">
                    <v-list-tile-content>
                      <v-list-tile-title class="text-xs-center">Sem empresas adicionadas</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>

    <v-card-actions class="justify-space-around ma-0 pa-0">
      <v-btn
        block
        large
        color="info"
        :disabled="disabled"
        @click="btnCadastrar"
      >
        <v-icon class="mr-1">save</v-icon>
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CadRedeEmpresas',
  data () {
    return {
      step: 1,
      nome: '',
      is_white_label: false,
      tabs: 0,
      cpf: undefined,
      id_pessoa: undefined,
      pessoa: undefined,
      alerta: false,
      empresas: [],
      empresasSemRede: [],
      empresasDaRede: [],
      empresaMatriz: null,
      loadingEmpresas: false,
      croppingLogo: false,
      croppingCapa: false,
      mostrar: true,
      mostrar2: true,
      imagem: null,
      capa: null,
      rede: null
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    disabled () {
      if (this.step === 1 && (!this.pessoa || !this.nome)) return true
      if (this.step === 3 && !this.empresaMatriz) return true
      return false
    }
  },
  watch: {
    id_pessoa (val) {
      if (val) this.pegarPessoa(false)
      else this.pessoa = undefined
    },
    cpf (val) {
      const digits = (val || '').replace(/\D/g, '')
      if (digits.length === 11) this.pegarPessoa(true)
      else this.pessoa = undefined
    },
    step (val) {
      if (val === 3) this.carregarEmpresas()
      if (val === 4) {
        if (!this.empresas.length) this.carregarEmpresas()
        this.empresasSemRede = Array.isArray(this.empresas) ? this.empresas.slice() : (this.empresas.results ? this.empresas.results.slice() : [])
        this.empresasDaRede = []
      }
    }
  },
  methods: {
    carregarLogo (event) {
      this.imagem = null
      this.mostrar = false
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0]
        const reader = new FileReader()
        reader.onloadend = () => {
          this.croppingLogo = true
          this.$refs.croppieRef.bind({ url: reader.result })
          this.$nextTick(() => this.$refs.croppieRef.setZoom(0.1))
        }
        reader.readAsDataURL(file)
      }
    },
    carregarImagem (event) {
      this.capa = null
      this.mostrar2 = false
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0]
        const reader = new FileReader()
        reader.onloadend = () => {
          this.croppingCapa = true
          this.$refs.croppieCapaRef.bind({ url: reader.result })
          this.$nextTick(() => this.$refs.croppieCapaRef.setZoom(0.1))
        }
        reader.readAsDataURL(file)
      }
    },
    recortarLogo () {
      this.mostrar = true
      const options = { type: 'base64', format: 'png', circle: true }
      this.$refs.croppieRef.result(options, output => {
        this.imagem = output
        this.croppingLogo = false
      })
    },
    recortarCapa () {
      this.mostrar2 = true
      const options = { type: 'base64', format: 'png' }
      this.$refs.croppieCapaRef.result(options, output => {
        this.capa = output
        this.croppingCapa = false
      })
    },
    pegarPessoa (isCPF) {
      const data = { is_admin: true }
      if (isCPF) data.cpf = this.cpf
      else data.id_pessoa = this.id_pessoa
      this.$store.dispatch('pegarPessoaPorId', data)
        .then(json => { this.alerta = false; this.pessoa = json })
        .catch(() => { this.alerta = true; this.pessoa = undefined })
    },
    carregarEmpresas () {
      if (this.empresas.length) return
      this.loadingEmpresas = true
      const data = { is_admin: true }
      const digits = (this.cpf || '').replace(/\D/g, '')
      if (this.id_pessoa && this.id_pessoa !== '') {
        data.id_pessoa = this.id_pessoa
      } else if (digits.length === 11) {
        data.cpf = digits
      }
      this.$store.dispatch('EmpresasSemRede', data)
        .then(value => {
          this.loadingEmpresas = false
          this.empresas = Array.isArray(value) ? value.slice() : (value.results || [])
          if (this.step === 4) {
            this.empresasSemRede = Array.isArray(this.empresas) ? this.empresas.slice() : (this.empresas.results ? this.empresas.results.slice() : [])
            this.empresasDaRede = []
          }
        })
        .catch(() => { this.loadingEmpresas = false })
    },
    inserirEmRede (emp, index) {
      this.empresasDaRede.push(emp)
      this.empresasSemRede.splice(index, 1)
    },
    removerDaRede (emp, index) {
      this.empresasSemRede.push(emp)
      this.empresasDaRede.splice(index, 1)
    },
    btnCadastrar () {
      switch (this.step) {
        case 1:
          this.$store.dispatch('cadastrarRedeEmpresa', {
            nome: this.nome,
            cpf: this.cpf || null,
            id_pessoa: this.id_pessoa || null,
            matriz: null,
            is_white_label: this.is_white_label
          }).then(rede => {
            const redeId = rede && (rede.id_rede_empresa || rede.id_rede || rede.id || rede.rede_id)
            if (!redeId) {
              this.$emit('error', 'ID da rede não retornado pelo servidor.')
              return
            }
            this.rede = { id_rede_empresa: redeId }

            if (this.imagem) {
              return this.$store.dispatch('inserirArquivoFirebase', {
                arquivo: this.imagem,
                rota: 'rede_empresas',
                id: redeId,
                local: 'logos',
                tipo: 'png'
              }).then(downloadUrl => {
                return this.$store.dispatch('atualizarRedeEmpresa', {
                  id_rede_empresa: redeId,
                  url_logo: downloadUrl
                })
              }).then(() => { this.step++ })
                .catch(() => { this.$emit('error', 'Erro ao enviar logo.') })
            } else {
              this.step++
            }
          }).catch(() => {
            this.$emit('error', 'Falha ao cadastrar rede de empresas.')
          })
          break

        case 2:
          if (this.capa && this.rede && this.rede.id_rede_empresa) {
            const id = this.rede.id_rede_empresa
            this.$store.dispatch('inserirArquivoFirebase', {
              arquivo: this.capa,
              rota: 'rede_empresas',
              id: id,
              local: 'capas',
              tipo: 'png'
            }).then(downloadUrl => {
              return this.$store.dispatch('atualizarRedeEmpresa', {
                id_rede_empresa: id,
                capa: downloadUrl
              })
            }).then(() => { this.step++ })
              .catch(() => { this.$emit('error', 'Erro ao enviar capa.') })
          } else {
            this.step++
          }
          break

        case 3:
          if (!this.empresaMatriz || !this.rede || !this.rede.id_rede_empresa) return
          {
            const id = this.rede.id_rede_empresa
            const matrizVal = this.empresaMatriz.id || this.empresaMatriz.cnpj
            this.$store.dispatch('atualizarRedeEmpresa', {
              id_rede_empresa: id,
              matriz: matrizVal
            }).then(() => { this.step++ })
              .catch(() => { this.$emit('error', 'Erro ao definir matriz.') })
          }
          break

        case 4:
          if (!this.empresasDaRede || this.empresasDaRede.length < 1) {
            alert('Adicione pelo menos uma empresa à rede antes de finalizar.')
            return
          }
          if (!this.rede || !this.rede.id_rede_empresa) {
            this.$emit('error', 'ID da rede não disponível para inserir empresas.')
            return
          }
          const lista = this.empresasDaRede.map(e => e.cnpj || e.id)
          const id = this.rede.id_rede_empresa
          this.$store.dispatch('inserirEmRedeEmpresa', { lista, id_rede_empresa: id })
            .then(() => {
              this.$emit('success', 'Rede de empresas cadastrada com sucesso.')
              this.$emit('fechar')
            })
            .catch(() => { this.$emit('error', 'Não foi possível inserir empresas na rede.') })
          break
      }
    }
  }
}
</script>
